module.exports = __webpack_public_path__ + "img/banner-1.bc45d9f5.png";